// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1SL_s","actions":"GroupTable_actions__V4L7C","deleteModalFooter":"GroupTable_deleteModalFooter__WPDWp"};